import React, { useState } from 'react';
import { Handle, Position } from 'reactflow';
import { Zap, Settings } from 'lucide-react';

const ActionNode = ({ data, selected }) => {
  const [showConfig, setShowConfig] = useState(false);
  
  return (
    <>
      <div className={`px-4 py-2 shadow-md rounded-lg bg-blue-500 text-white border-2 ${
        selected ? 'border-blue-300' : 'border-blue-600'
      }`}>
        <div className="flex items-center justify-between">
          <div className="flex items-center space-x-2">
            <Zap className="h-4 w-4" />
            <div className="text-sm font-medium">{data.label}</div>
          </div>
          <button
            onClick={() => setShowConfig(true)}
            className="p-1 hover:bg-blue-600 rounded"
          >
            <Settings className="h-3 w-3" />
          </button>
        </div>
        
        {data.config?.description && (
          <div className="text-xs mt-1 opacity-90">
            {data.config.description}
          </div>
        )}
        
        <Handle
          type="target"
          position={Position.Top}
          style={{
            background: '#3b82f6',
            border: '2px solid #2563eb',
          }}
        />
        <Handle
          type="source"
          position={Position.Bottom}
          style={{
            background: '#3b82f6',
            border: '2px solid #2563eb',
          }}
        />
      </div>

      {showConfig && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white rounded-lg p-6 w-96">
            <h3 className="text-lg font-semibold mb-4">Configure Action Node</h3>
            <div className="space-y-4">
              <div>
                <label className="block text-sm font-medium text-gray-700">Action Type</label>
                <select className="mt-1 w-full border rounded-lg px-3 py-2">
                  <option>Send Email</option>
                  <option>Update Record</option>
                  <option>Call API</option>
                  <option>Execute Script</option>
                </select>
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700">Description</label>
                <textarea 
                  className="mt-1 w-full border rounded-lg px-3 py-2"
                  placeholder="Describe what this action does..."
                />
              </div>
            </div>
            <div className="flex justify-end space-x-2 mt-6">
              <button
                onClick={() => setShowConfig(false)}
                className="px-4 py-2 border rounded-lg hover:bg-gray-50"
              >
                Cancel
              </button>
              <button
                onClick={() => setShowConfig(false)}
                className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700"
              >
                Save
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default ActionNode;